<!--
兑换按钮

使用说明：

<ActionButton
 :text="'立即兑换'"
 />


-->

<template>
<div class="wrap">
  <button class="action-btn" @click="doAction">{{text}}</button>
</div>
</template>

<script>
export default {
  props: ['text'],
  data() {
    return {};
  },
  methods: {
    doAction() {
      this.$emit('click');
    }
  }
}
</script>

<style lang="less" scoped>
.wrap {
  position: fixed;
  z-index: 3;
  bottom: 0;
  left: 0;
  right: 0;
  background: #fff;
  height: 16.53vw;
  .action-btn {
    background-image: linear-gradient(to right, #ff0d33, #ff7f5f);
    color: #fff;
    height: 12vw;
    width: 92vw;
    line-height: 12vw;
    font-size: 4.26vw;
    border: none;
    display: block;
    margin: 2.53vw auto;
    border-radius: 6vw;
  }
}
</style>






// WEBPACK FOOTER //
// src/components/products/form/ActionButton.vue